<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>帐号管理</el-breadcrumb-item>
        <el-breadcrumb-item>职能管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog" >添加职能</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="role_name"
            width="220"
            label="职能名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="menu_list"
            label="职能权限">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="320">
            <template slot-scope="scope" >
              <el-button
                type="primary"
                size="small"
                v-show="scope.row.id !== 1000"
                @click="editDialog(scope.row.id)">编辑
              </el-button>
              <el-popconfirm
                v-show="scope.row.id !== 1000"
                confirmButtonText='确认'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogAddVisible"  :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="addForm" label-width="120px" :rules="storeRoleRules" ref="addForm">
        <el-form-item label="职能名称" prop="role_name">
          <el-input v-model="addForm.role_name" auto-complete="off" placeholder="请输入职能名称"></el-input>
        </el-form-item>
        <el-form-item label="职能权限" prop="role_name">
          <el-select v-model="addForm.menu_ids" multiple placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="add('addForm')">确 定</el-button>
        <el-button @click="callOf('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogEditVisible" :close-on-click-modal="false" width="600px" class="padding_10">
      <el-form :model="editForm" label-width="120px" :rules="storeRoleRules" ref="editForm">
        <el-form-item label="职能名称" prop="role_name">
          <el-input v-model="editForm.role_name" auto-complete="off" placeholder="请输入职能名称"></el-input>
        </el-form-item>
        <el-form-item label="职能权限" prop="role_name">
          <el-select v-model="editForm.menu_ids" multiple placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in menuList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="edit('editForm')">确 定</el-button>
        <el-button @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" >
  .el-transfer__button{
    display: block!important;
    width: 100%;
  }
  .el-button+.el-button{
    margin: 0;
  }
  .el-checkbox{
    margin: 0;
    text-align: left;
  }
  .el-transfer-panel__item{
    width: 100%;
    max-width: 200px;
  }
  .el-transfer-panel__list{
    overflow-x:hidden;
  }
</style>

<script>
import {addRole, delRole, editRole, menuList, roleInfo, roleList} from '../../api/auth'

export default {
  data () {
    return {
      dialogAddVisible: false,
      dialogEditVisible: false,
      dialogTitle: '',
      tableData: [],
      page: 1,
      page_size: 50,
      total: 0,
      menuList: [],
      addForm: {
        role_name: '',
        menu_ids: []
      },
      editForm: {
        id: 0,
        role_name: '',
        menu_ids: []
      },
      storeRoleRules: {
        role_name: [
          { required: true, message: '请输入职能名称', trigger: 'blur' }
        ],
        menu_ids: [
          { required: true, message: '请选择职能权限', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.setTableData()
    this.getMenuList()
  },
  methods: {
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 表格渲染
    setTableData () {
      roleList({
        page: this.page,
        page_size: this.page_size
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.total = res.data.total
          this.tableData = res.data.table_list
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加弹窗
    addDialog () {
      this.dialogTitle = '添加职能'
      this.dialogAddVisible = true
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogAddVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditVisible = false
      }
      if (formName) {
        this.fileList = []
        this.file = {}
        this.$refs[formName].resetFields()
      }
    },
    // 获取所有菜单
    getMenuList () {
      menuList().then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.menuList = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 添加职能
    add (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addRole(this.addForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.dialogAddVisible = false
              this.setTableData()
              this.$refs[formName].resetFields()
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    // 编辑弹窗
    editDialog (id) {
      this.dialogEditVisible = true
      this.dialogTitle = '编辑职能'
      roleInfo({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.editForm = res.data
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 编辑提交
    edit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          editRole(this.editForm).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.dialogEditVisible = false
              this.setTableData()
              this.$refs[formName].resetFields()
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
    },
    // 删除职能
    del (id) {
      delRole({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/role/index.vue